export const routes = [
    { label: 'Met wie kom je?', url: '/tickets' },
    { label: 'Plan je bezoek', url: '/plan-je-bezoek' },
    { label: 'Arrangementen', url: '/arrangementen' },
    { label: 'Donatie', url: '/donatie' },
    { label: 'Gegevens', url: '/gegevens' },
    { label: 'Overzicht', url: '/overzicht' },
]

export const config = {
    webSiteUrl: 'https://muzieum.nl',
    allowedParams: ['adults', 'kids', 'cards', 'tid'], // List of allowed url parameters that can be used to pre-select data
    donationAmounts: [
        {text: '5', value: 5},
        {text: '10', value: 10},
        {text: '25', value: 25},
        {text: 'Anders, namelijk:', value: 'custom'},
    ],
    genderOptions: [
        { text: 'Mevrouw', value: 'Female' },
        { text: 'De heer', value: 'Male' },
        { text: 'Geen aanhef', value: 'Unknown' },
    ]
}
